/* global dataLayer:writable */
import Cookies from 'js-cookie';
import * as helpers from './utils/helpers';

let trackingInstance = null;
export default class Tracking {
  constructor(product, version, etUrl = '/et/get-session-data', removeParam = '', etUid = null) {
    if (typeof product === 'undefined' || typeof version === 'undefined') {
      throw new Error('Please initialize Tracking with product and version');
    }

    if (!trackingInstance) {
      this.product = product;
      this.version = version;
      this.referrer = helpers.getUrlParam('referrer');
      this.pageUrl = helpers.getPageUrl();
      this.sessionUrl = `${etUrl}?product=${this.product}&version=${this.version}`;
      trackingInstance = this;

      this.loadSessionData(this.sessionUrl, this.pageUrl, this.referrer, removeParam, etUid).then(
        () => {
          if (typeof window.et_steps_queue !== 'undefined') {
            window.et_steps_queue.forEach((data) => {
              this.trackStepEt(data.step, data.name, data.action);
            });
            delete window.et_steps_queue;
          }
        }
      );

      this.trackStepEt('1', '1', 'load');
    }

    return trackingInstance;
  }

  async loadSessionData(sessionUrl, pageUrl, referrer = '', removeParam = '', etUid = null) {
    const formData = new FormData();
    formData.append('page_url', helpers.removeParamFromUrl(removeParam, pageUrl));
    formData.append('referrer', helpers.removeParamFromUrl(removeParam, referrer));
    if (etUid) {
      // eslint-disable-next-line no-param-reassign
      sessionUrl += `&etuid=${etUid}`;
    }

    await fetch(sessionUrl, {
      method: 'post',
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.etSessionId = data['et-session-id'];
        this.etUserId = data['et-user-id'];
        this.etVisitId = data['et-visit-id'];
        Tracking.trackDatalayer({ user_id: this.etUserId });
      });
  }

  static disableTracking() {
    this.trackDatalayer({ disableTracking: true });
  }

  trackStepEt(step, name, action) {
    if (typeof this.etSessionId === 'undefined') {
      setTimeout(() => {
        this.trackStepEt(step, name, action);
      }, 500);
      return;
    }

    /* eslint-disable */
    const etData = {
      action: action,
      et_session_id: this.etSessionId,
      et_user_id: this.etUserId,
      et_visit_id: this.etVisitId,
      name: name,
      order_id: this.etSessionId,
      step: step,
      wizard_name: this.product,
      wizard_version: this.version,
    };
    /* eslint-enable */
    const data = helpers.objectToFormData(etData);

    fetch('/et/engagement', {
      method: 'post',
      body: data,
    }).then(() => {
      // eslint-disable-next-line
      // console.log('et conversion');
    });
  }

  static trackDatalayer(data) {
    if (typeof dataLayer !== 'undefined') {
      dataLayer.push(data);
      // console.log(data);
    }
  }

  /**
   *
   * @param etData {object}
   */
  static trackConversion(etData) {
    const conversionData = {
      name: 'conversion',
      action: 'conversion',
    };

    const data = helpers.objectToFormData({ ...etData, ...conversionData });

    fetch('/et/engagement', {
      method: 'post',
      body: data,
    }).then(() => {
      // eslint-disable-next-line
      // console.log('et conversion');
    });
  }

  static trackProspect(etData) {
    const data = helpers.objectToFormData({ ...etData, ...{ prospect_type: 'lead-prospect' } });

    fetch('/et/prospect', {
      method: 'post',
      body: data,
    }).then(() => {
      // eslint-disable-next-line
      // console.log('et conversion');
    });
  }

  static trackStep(stepname) {
    if (typeof stepname === 'undefined') {
      throw new Error('Please provide stepname');
    }
    Tracking.trackDatalayer({
      event: 'wizard_step_show',
      wizard_step_show: stepname,
    });
  }

  static getCID() {
    const match = window.location.href.match(/CID=([a-zA-Z0-9_\-.]+)/);
    if (match) {
      return match[1];
    }
    if (typeof Cookies.get('cid_flow') !== 'undefined') {
      const cidFlow = Cookies.get('cid_flow').split('|');
      return cidFlow[cidFlow.length - 1];
    }
    return null;
  }

  static queueStep(data) {
    if (typeof window.et_steps_queue === 'undefined') {
      window.et_steps_queue = [];
    }
    window.et_steps_queue.push(data);
  }

  static trackCuraboxInput(action, label) {
    Tracking.trackDatalayer({
      category: 'ZWB',
      event: `form-${action}`,
      label: `curabox-input-${label}`,
    });
  }
}
